export default "__VITE_ASSET__DgvVWNbY__"